import { useI18n } from '../context/I18nContext';
import { useAnalytics } from '../hooks/useAnalytics';

const SHARE_URL = 'https://hexopdf.com';
const SHARE_HASHTAGS = 'HexoPDF,PDFEditor,NoSubscription';

const platforms = [
  {
    id: 'twitter',
    label: 'Twitter / X',
    color: 'hover:bg-white/10 hover:border-white/20',
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
    getUrl: (text) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(SHARE_URL)}&hashtags=${SHARE_HASHTAGS}`,
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    color: 'hover:bg-blue-600/10 hover:border-blue-500/30',
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
    getUrl: () => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(SHARE_URL)}`,
  },
  {
    id: 'discord',
    label: 'Discord',
    color: 'hover:bg-indigo-600/10 hover:border-indigo-500/30',
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
        <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189z" />
      </svg>
    ),
    getUrl: () => 'https://discord.gg/vwfdvYPp',
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    color: 'hover:bg-emerald-600/10 hover:border-emerald-500/30',
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
    getUrl: (text) => `https://wa.me/?text=${encodeURIComponent(text + ' ' + SHARE_URL)}`,
  },
];

const labels = {
  en: { cta: 'Share with your network' },
  fr: { cta: 'Partagez avec votre réseau' },
  es: { cta: 'Comparte con tu red' },
  de: { cta: 'Teile es mit deinem Netzwerk' },
  hi: { cta: 'अपने नेटवर्क के साथ साझा करें' },
};

const shareTexts = {
  en: "I just joined the HexoPDF waitlist, an offline PDF editor with text extraction, no subscription. Check it out!",
  fr: "Je viens de rejoindre la waitlist HexoPDF, un editeur PDF hors ligne avec extraction de texte, sans abonnement. Jetez un oeil !",
  es: "Acabo de unirme a la lista de espera de HexoPDF, un editor PDF offline con extraccion de texto, sin suscripcion.",
  de: "Ich habe mich gerade auf die HexoPDF-Warteliste eingetragen, ein Offline-PDF-Editor mit Texterkennung, ohne Abo.",
  hi: "Maine abhi HexoPDF waitlist mein shamil hua, paath nishkarshan ke saath offline PDF sampadak, bina sadasyta. Dekhein!",
};

export const SocialShare = () => {
  const { lang } = useI18n();
  const { trackShare } = useAnalytics();
  const l = labels[lang] || labels.en;
  const shareText = shareTexts[lang] || shareTexts.en;

  const handleShare = (platform) => {
    trackShare(platform.id);
    window.open(platform.getUrl(shareText), '_blank', 'noopener,noreferrer,width=600,height=400');
  };

  return (
    <div className="flex flex-col gap-2" data-testid="social-share">
      <span className="text-xs text-muted-foreground font-medium">{l.cta}</span>
      <div className="flex gap-2">
        {platforms.map((p) => (
          <button
            key={p.id}
            onClick={() => handleShare(p)}
            className={`flex items-center justify-center w-9 h-9 rounded-full border border-border text-muted-foreground transition-all duration-200 ${p.color}`}
            aria-label={p.label}
            data-testid={`share-btn-${p.id}`}
          >
            {p.icon}
          </button>
        ))}
      </div>
    </div>
  );
};
